export const genders = ["Male", "Female"] as const;
